export default __webpack_public_path__ + "static/media/speaker2.fe74f45a.jpg";